export const CUSTOM_USER_PROPERTY_ATTRIBUTE_PREFIX = 'user_properties.';

// Course visibility predicates and filter predicates both use `user_properties.<id>`.
// Historically `<id>` was numeric, but newer installs may use non-numeric ids.
const CUSTOM_USER_PROPERTY_ATTRIBUTE_PATTERN = /^user_properties\.[^.]+$/;

export function normalizePredicateBooleanValue(value: unknown): boolean | null {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return null;
}

export function isPredicateBooleanValueSet(value: unknown): boolean {
  return normalizePredicateBooleanValue(value) !== null;
}

export function isCustomUserPropertyAttribute(
  attribute: string | null | undefined
): attribute is string {
  return (
    typeof attribute === 'string'
    && CUSTOM_USER_PROPERTY_ATTRIBUTE_PATTERN.test(attribute)
  );
}

export function parseCustomUserPropertyId(attribute: string): string {
  return attribute.slice(CUSTOM_USER_PROPERTY_ATTRIBUTE_PREFIX.length);
}

export function buildCustomUserPropertyAttribute(propertyId: string): string {
  return `${CUSTOM_USER_PROPERTY_ATTRIBUTE_PREFIX}${propertyId}`;
}
